<template>
  <div v-loading="loading || !publishRules.length">
    <p
      v-dompurify-html="introduction"
      class="publish-rules-modal__introduction"
    />
    <ElCollapse v-model="activeCollapseItem" accordion>
      <ElCollapseItem
        v-for="(rule, index) of publishRules"
        :key="index"
        :title="rule.title"
        :name="index"
      >
        <p
          v-dompurify-html="rule.description"
          class="publish-rules-modal__description"
        />
      </ElCollapseItem>
    </ElCollapse>
    <div
      v-if="haveDontShowAgainOption"
      class="publish-rules-modal__dont-show-again"
    >
      <ElCheckbox v-model="dontShowRulesAgain">
        {{ $t('APP.RELEASES.PUBLISH_RULES.DONT_SHOW_AGAIN') }}
      </ElCheckbox>
    </div>
    <ElButton
      class="publish-rules-modal__confirm"
      type="primary"
      @click="confirm"
    >
      {{ $t('APP.RELEASES.PUBLISH_RULES.CONFIRM') }}
    </ElButton>
  </div>
</template>

<script>
import { CHANGE_AGENT_PREFERENCE } from '@/store/types';
import packageName from '@/mixins/packageName';
import { Categories } from '@/api/api';
import { mapActions } from 'vuex';

export default {
  name: 'PublishRulesModal',
  mixins: [packageName],
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    haveDontShowAgainOption: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      introduction: '',
      publishRules: [],
      dontShowRulesAgain: false,
      activeCollapseItem: 0,
    };
  },
  created() {
    this.getPublishRules();
  },
  methods: {
    ...mapActions({
      changeAgentPreference: CHANGE_AGENT_PREFERENCE,
    }),
    confirm() {
      if (this.dontShowRulesAgain) {
        this.unsetShowingRules();
      }
      this.$modal.close(true);
      this.resetAndClose();
    },
    resetAndClose() {
      this.dontShowRulesAgain = false;
    },
    getPublishRules() {
      this.loading = true;

      return Categories.getPublishRules({
        categoryId: this.categoryId,
      })
        .then(({ publishRules = [], introduction = '' }) => {
          this.publishRules = publishRules;
          this.introduction = introduction;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    unsetShowingRules() {
      this.changeAgentPreference({
        name: 'show_publish_rules',
        app: this.packageName,
        value: false,
      });
    },
  },
};
</script>

<style lang="scss">
.publish-rules-modal {
  &__loading {
    padding-top: $global-padding;
    padding-bottom: $global-padding * 2;
    display: flex;
    justify-content: center;
  }

  &__show-rules {
    margin-top: $global-margin * 1.5;
  }

  &__confirm {
    margin-top: $global-margin * 1.5;
  }

  &__dont-show-again {
    margin-top: $global-margin * 1.5;
  }

  &__introduction {
    margin-top: -1.5 * $global-margin;
    margin-bottom: $global-margin * 1.5;
    font-size: 0.8rem;
  }

  &__description {
    margin-top: calc($global-margin / 2);
    margin-left: calc($global-margin / 2);
  }
}
</style>
